import cx from 'classnames'
import React, { HTMLProps } from 'react'
import * as styles from '../styles/components/small-title.module.scss'

export type SmallTitleProps = HTMLProps<HTMLHeadingElement>

const SmallTitle = ({ className, children, as = 'div', ...rest }: SmallTitleProps) => {
    const props = { className: cx(styles.title, className), ...rest }
    const H = as

    return <H {...props}>{children}</H>
}

export default SmallTitle
